import React, { useEffect, useState } from "react";
import InputEmoji from "react-input-emoji";
import "emoji-mart/css/emoji-mart.css";
import {
  DocumentIcon,
  VideoCameraIcon,
  CodeIcon,
  PhotographIcon,
  MicrophoneIcon,
  PaperAirplaneIcon,
  PlusIcon,
  StopIcon,
  TrashIcon,
  EmojiHappyIcon,
} from "@heroicons/react/solid";
import { EmojiHappyIcon as OutlineHappyIcon } from "@heroicons/react/outline";
import { useFileUpload } from "use-file-upload";
import backendService from "../services.js/backendService";
import recorder from "../services.js/recorder";
//import blink from react blink
import { socket, SocketContext } from "../services.js/socket";
import ClickAwayListener from "react-click-away-listener";
import CodeSnippetModal from "./CodeSnippetModal";
import { createPopper } from "@popperjs/core";
import { MentionsInput, Mention } from "react-mentions";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { set } from "react-hook-form";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
function className(...classes) {
  return classes.filter(Boolean).join(" ");
}
function ChatInput(props) {
  const [file, selectFile] = useFileUpload();
  const socket = React.useContext(SocketContext);
  const [isInputEmpty, setIsInputEmpty] = React.useState(true);
  const [inputText, setInputText] = React.useState("");
  const [recording, setRecording] = React.useState(false);
  const [dontsend, setDontsend] = React.useState(false);
  let [audioURL, isRecording, startRecording, stopRecording] = recorder();
  const [showCodeSnippetModal, setShowCodeSnippetModal] = useState(false);
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const [show, setShow] = useState(false);
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const [emojiPopoverShow, setEmojiPopoverShow] = React.useState(false);
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "top-start",
      modifiers: [
        {
          name: "offset",
          options: {
            offset: [0, 15],
          },
        },
      ],
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  const onEmojiClick = (event, emojiObject) => {
    setInputText(inputText + emojiObject.emoji);
  };

  const openCodeSnippetModal = (data) => {
    setShowCodeSnippetModal(data);
   
  };

  useEffect(() => {
    if (!dontsend && audioURL) {
      props.sendAudioData(audioURL);
    }
  }, [audioURL]);

  const codeSnippetModal = () => {
    return (
      <CodeSnippetModal
        openCodeSnippetModal={openCodeSnippetModal}
        sendCodeData={props.sendCodeData}
      />
    );
  };

  useEffect(() => {
    if (inputText.length > 0) {
      if (props.userInfo.groupName) {
        props.userInfo.participants.forEach((participant) => {
          socket.emit("typing", {
            senderId: backendService.getLoggedInUser()._id,
            receiverId: participant._id,
            text: inputText,
          });
        });
      } else {
        socket.emit("typing", {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: props.userInfo.participants[0]?._id,
          text: inputText,
        });
      }
    } else if (inputText.length === 0 && isInputEmpty === true) {
      if (props.userInfo.groupName) {
        props.userInfo.participants.forEach((participant) => {
          socket.emit("typing", {
            senderId: backendService.getLoggedInUser()._id,
            receiverId: participant._id,
            text: "",
          });
        });
      } else {
        socket.emit("typing", {
          senderId: backendService.getLoggedInUser()._id,
          receiverId: props.userInfo.participants[0]?._id,
          text: "",
        });
      }
    }
  }, [inputText, isInputEmpty]);

  useEffect(() => {
    props.getInputText(inputText);
  }, [inputText, props]);

  React.useEffect(() => {
    if (inputText.length > 0) {
      setIsInputEmpty(false);
    } else {
      setIsInputEmpty(true);
    }
  }, [inputText]);
  let bgColor;
  let color = "white";
  color === "white"
    ? (bgColor = "bg-blueGray-700")
    : (bgColor = "bg-" + color + "-500");
  const defaultStyle = {
    display: "block",
    width: "100%",
    height: "100%",
    borderRadius: "1.5rem",
    border: "none",
    verticalAlign: "middle",
    control: {
      backgroundColor: "#ffffff",
      fontSize: "1rem",
      fontWeight: "normal",
      border: "solid 1px #764deb",
      borderRadius: "1rem",
      height: "80%",
      color: "#000000",
      verticalAlign: "middle",
    },
    highlighter: {
      overflow: "hidden",
    },
    input: {
      overflow: "auto",
      borderRadius: "1rem",
      border: "none",
      width: "100%",
      height: "80%",
      verticalAlign: "middle",
      paddingLeft: "8px",
      "&active": {
        border: "none",
      },
    },
    "&multiLine": {
      control: {
        backgroundColor: "#242526",
        fontSize: "1rem",
        fontWeight: "normal",
        borderRadius: "1.5rem",
        height: "80%",
        verticalAlign: "middle",
      },
      // highlighter: {
      //   padding: 9,
      // },
      input: {
        overflow: "auto",
        borderRadius: "1.5rem",
        width: "100%",
        height: "80%",
        verticalAlign: "middle",
      },
    },
    suggestions: {
      bottom: "50px",
      top: "unset",
      marginLeft: "1.5rem",
      overflowY: "auto",
      list: {
        backgroundColor: "#ffffff",
        fontSize: 14,
      },
      item: {
        padding: "5px 15px",
        color: "#0077b6",
        backgroundColor: "#ffffff",

        "&focused": {
          backgroundColor: "#0077b6",
          color: "#ffffff",
          border: "none",
        },
      },
    },
  };
  const tagData = props.userInfo.participants.map((participant) => {
    return {
      id: participant.username,
      display: participant.firstname + " " + participant.lastname,
    };
  });
  return (
    <>
      {showCodeSnippetModal && codeSnippetModal()}

      <div className="flex h-[60px] w-full shadow bg-gray-100">
        <ReactTooltip delayShow={500} delayHide={100} />
        <div className="flex flex-none justify-evenly items-center px-2 sm:px-3 ">
          {/* plus icon */}
          <ClickAwayListener onClickAway={closeDropdownPopover}>
            <div className="flex  items-center pl-3 ">
              <div
                className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full"
                type="button"
                ref={btnDropdownRef}
                onClick={() => {
                  dropdownPopoverShow
                    ? closeDropdownPopover()
                    : openDropdownPopover();
                }}
                data-tip="Attachments"
                data-place="top"
              >
                <PlusIcon className="h-5 w-5 " />
              </div>
              <div
                ref={popoverDropdownRef}
                className={
                  (dropdownPopoverShow ? "block " : "hidden ") +
                  "text-base z-50 float-left  list-none text-left rounded-lg shadow-md shadow-black mb-1 bg-palette_color2"
                }
                style={{ minWidth: "12rem" }}
              >
                <div
                  className="flex justify-items-stretch w-full items-center pl-3 cursor-pointer  py-2 text-sm hover:bg-palette_color1 text-palette_color1 hover:text-palette_color2 hover:rounded-t-md"
                  onClick={() => {
                    selectFile(
                      { accept: "*/*" },
                      ({ source, name, size, file }) => {
                        if (size < 50 * 1024 * 1024) {
                          props.sendFileData(file);
                        } else {
                          toast.error("File size should be less than 50 MB");
                        }
                      }
                    );
                  }}
                >
                  <DocumentIcon className="h-5 w-5 " />
                  <span className="ml-2  font-robo ">Send File</span>
                </div>
                <div
                  className="flex justify-items-stretch w-full items-center pl-3 cursor-pointer py-2 text-sm hover:bg-palette_color1 text-palette_color1 hover:text-palette_color2 "
                  onClick={() => {
                    selectFile(
                      { accept: "video/*" },
                      ({ source, name, size, file }) => {
                        if (size < 50 * 1024 * 1024) {
                          if (file.type.includes("video")) {
                            props.sendVideoData(file);
                          } else {
                            toast.error("File should be a video");
                          }
                        } else {
                          toast.error("File size should be less than 50 MB");
                        }
                      }
                    );
                  }}
                >
                  <VideoCameraIcon className="h-5 w-5 " />
                  <span className="ml-2  font-robo ">Send Video</span>
                </div>
                <div
                  className="flex justify-items-stretch w-full items-center pl-3 cursor-pointer py-2  text-sm hover:bg-palette_color1 text-palette_color1 hover:text-palette_color2  hover:rounded-b-md"
                  onClick={() => {
                    selectFile(
                      { accept: "image/*" },
                      ({ source, name, size, file }) => {
                        if (size < 10 * 1024 * 1024) {
                          if (file.type.includes("image")) {
                            props.sendImageData(file);
                          } else {
                            toast.error("File should be an image");
                          }
                        } else {
                          toast.error("File size should be less than 10 MB");
                        }
                      }
                    );
                  }}
                >
                  <PhotographIcon className="h-5 w-5 " />
                  <span className="ml-2  font-robo ">Send Image</span>
                </div>
              </div>
            </div>
          </ClickAwayListener>
          {/* code icon */}
          <div
            className="flex items-center justify-center h-7 w-7 mr-1  hover:bg-palette_color1 text-palette_color1 hover:text-palette_color2  hover:rounded-full cursor-pointer"
            data-tip="Code Snippet"
            data-place="top"
          >
            <CodeIcon
              className="h-5 w-5 text-primary cursor-pointer"
              onClick={() => setShowCodeSnippetModal(true)}
            />
          </div>
        </div>
        {/* input */}
        <div className="flex flex-grow min-w-0 max-w-[100%] align-middle justify-center items-center pt-2 max-h-full">
          {/* <InputEmoji
            className=" focus:outline-none focus:placeholder-gray-400 placeholder-gray-200  bg-gray-200  "
            onEnter={() => {
              props.send();
            }}
            type="text"
            placeholder="Type message here..."
            value={inputText}
            cleanOnEnter
            theme="auto"
            onChange={setInputText}
            height={10}
          /> */}
          <MentionsInput
            className="justify-center w-full h-full "
            style={defaultStyle}
            placeholder=" Type message here..."
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                props.send();
                setInputText("");
              }
            }}
            value={inputText}
            onChange={(e, newValue, newPlainTextValue, mentions) => {
              setInputText(newValue);
            }}
            singleLine={true}
          >
            {props.userInfo.state === "grouped" ? (
              <Mention trigger="@" markup="@__id__" data={tagData} />
            ) : (
              <Mention trigger="@" markup="@__id__" data={[]} />
            )}
          </MentionsInput>
        </div>
        <div className="flex flex-none justify-evenly items-center px-2 sm:px-3">
          <div
            className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full "
            onClick={() => {
              emojiPopoverShow
                ? setEmojiPopoverShow(false)
                : setEmojiPopoverShow(true);
            }}
            data-tip="Emoji"
            data-place="top"
          >
            <OutlineHappyIcon className="h-5 w-5" />
          </div>

          {emojiPopoverShow && (
            <ClickAwayListener
              onClickAway={() => {
                setEmojiPopoverShow(false);
              }}
            >
              <Picker
                style={{ position: "absolute", bottom: "60px", right: "5px", width: "clamp(280px, 90vw, 350px)" }}
                theme="light"
                showPreview={false}
                showSkinTones={false}
                onSelect={(emoji) => {
                  setInputText(inputText + emoji.native);
                  setEmojiPopoverShow(false);
                }}
              />
            </ClickAwayListener>
          )}
          {/* mic icon */}
          {isInputEmpty ? (
            !recording ? (
              <div className="flex items-center justify-start px-2">
                <div
                  className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full"
                  onClick={() => {
                    setRecording(true);
                    startRecording();
                  }}
                  data-tip="Voice Note"
                  data-place="top"
                >
                  <MicrophoneIcon className="h-5 w-5 " />
                </div>
              </div>
            ) : (
              <>
                <div
                  className="flex items-center justify-between "
                  onClick={() => {
                    setRecording(false);
                    stopRecording();
                    setDontsend(false);
                  }}
                >
                  <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full  ">
                    <PaperAirplaneIcon className="h-5 w-5 rotate-90 " />
                  </div>
                  <MicrophoneIcon className="h-5 w-5 text-red animate-pulse" />
                </div>
                <div className="flex items-center justify-start px-2">
                  <div
                    className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full"
                    onClick={() => {
                      setRecording(false);
                      setDontsend(true);
                      stopRecording();
                    }}
                  >
                    <TrashIcon className="h-5 w-5 " />
                  </div>
                </div>
              </>
            )
          ) : (
            <div
              className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full"
              onClick={() => {
                props.send();
                setInputText("");
              }}
            >
              <PaperAirplaneIcon className="h-5 w-5 rotate-90 " />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
export default ChatInput;
